import { DEFAULT_QUERY_OPTIONS, useInfiniteQueryWithBoundary } from '@/shared/lib/query';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { getTagCategoriesApi } from '@/features/tags/api';
import type { TagCategoryResponse } from '@/features/tags/api/getTagCategoriesApi';

type UseTagCategoriesParams = {
  limit?: number;
};

export const useTagCategories = ({ limit = 3000 }: UseTagCategoriesParams = {}) => {
  return useInfiniteQueryWithBoundary({
    queryKey: tagKeys.categories(),
    queryFn: async ({ pageParam }: { pageParam: string }): Promise<TagCategoryResponse> => {
      return getTagCategoriesApi({ limit, after: pageParam || '' });
    },
    getNextPageParam: (lastPage: TagCategoryResponse) => lastPage.paging.after,
    initialPageParam: '',
    select: (data: { pages: TagCategoryResponse[] }) => {
      if (!data) return [];
      if (data.pages.length === 0) return [];

      return data.pages.flatMap((page: TagCategoryResponse) => page.data);
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
